import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import PlanCard from './components/PlanCard'
import { PLANS } from '../../constants/plans'
import PricingTable from 'components/PricingTable/PricingTable'
import { ALL_FEATURES, PRICING_FEATURES } from '../../constants/plans'

import { LogoShowcase } from '../../Landing/Home/Home'

import styles from './PricingGrid.module.css'

const PricingGrid = ({ className, period, prices, onSubPlanClick, onFreeClick, hideFreeCard, hideTable }) => {
  const [hideFreePlan, setHideFreePlan] = useState(hideFreeCard)
  const history = useHistory()

  useEffect(() => {
    // Check if user is from ad flow
    const isAdFlow = localStorage.getItem('adFlow') === 'true'
    if (isAdFlow) {
      setHideFreePlan(true)
    } else {
      setHideFreePlan(hideFreeCard)
    }
  }, [hideFreeCard])
  return (
    <>
      <div className={`${className} ${styles.container} mb-2`}>
        {!hideFreePlan && (
          <PlanCard
            title="Free"
            plan={PLANS.FREE}
            planPrice={prices.freePlan}
            subtitle="Try us out to quickly share a project"
            features={PRICING_FEATURES[PLANS.FREE.id]}
            period={period}
            ctaTheme="black"
            onSubPlanClick={onFreeClick}
          />
        )}
        <PlanCard
          plan={PLANS.TINY}
          planPrice={prices.tinyPlan}
          title="Tiny"
          subtitle="Perfect for a single, professional link"
          features={PRICING_FEATURES[PLANS.TINY.id]}
          period={period}
          ctaTheme="blue"
          onSubPlanClick={onSubPlanClick}
          hideCompareCTA={hideTable}
          dataTestId="PricingGrid-tiny-plan"
        />
        <PlanCard
          plan={PLANS.PRO}
          planPrice={prices.soloPlan}
          title="Solo"
          subtitle="Great for individuals & small projects"
          features={PRICING_FEATURES[PLANS.PRO.id]}
          period={period}
          ctaTheme="purple"
          onSubPlanClick={onSubPlanClick}
          hideCompareCTA={hideTable}
          dataTestId="PricingGrid-solo-plan"
          popular
        />
        <PlanCard
          plan={PLANS.PRO_U}
          planPrice={prices.proPlan}
          title="Pro"
          subtitle="For freelancers, agencies & companies"
          features={PRICING_FEATURES[PLANS.PRO_U.id]}
          period={period}
          ctaTheme="warning"
          onSubPlanClick={onSubPlanClick}
          hideCompareCTA={hideTable}
          dataTestId="PricingGrid-pro-plan"
        />
      </div>
      <div className={styles.enterpriseContainer}>
        <div className={styles.enterpriseContent}>
          <span>Need something custom? Talk to us for enterprise plans</span>
        </div>
        <Button
          className={styles.enterpriseButton}
          size="sm"
          variant="outline-light"
          onClick={() => history.push('/contact-sales')}
        >
          Contact sales
        </Button>
      </div>
      {!hideTable && (
        <>
          <LogoShowcase title="Do more with your links" className="mt-2 mb-5" />
          <PricingTable plans={PLANS} prices={prices} period={period} featureList={ALL_FEATURES} history={history} />
        </>
      )}
    </>
  )
}

export default PricingGrid
